module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#youtube",
      toString: function () {
        return this.url;
      }
    }